import React from 'react';
import { IconProps } from 'types';

const ThreadsIcon = ({ color, className }: IconProps) => {
  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 289.19 219.26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle
          cx="144.59"
          cy="109.63"
          r="130"
          fill={`${color ? color : '#000'}`}
        />
        <path
          fill={`${color ? '#000' : '#FFF'}`}
          d="M175.58,104.9c-0.56-0.27-1.12-0.52-1.7-0.77c-1-18.42-11.06-28.96-27.96-29.07c-0.08,0-0.15,0-0.23,0
            c-10.11,0-18.51,4.31-23.69,12.16l9.29,6.37c3.86-5.86,9.93-7.11,14.4-7.11c0.05,0,0.1,0,0.15,0c5.56,0.04,9.76,1.65,12.48,4.81
            c1.98,2.3,3.3,5.47,3.95,9.48c-4.93-0.84-10.27-1.1-15.97-0.77c-16.07,0.93-26.39,10.3-25.7,23.31c0.35,6.6,3.64,12.29,9.26,16
            c4.75,3.14,10.87,4.67,17.24,4.32c8.4-0.46,14.99-3.67,19.59-9.53c3.49-4.45,5.7-10.22,6.68-17.49c4,2.42,6.97,5.6,8.61,9.42
            c2.79,6.5,2.95,17.18-5.76,25.88c-7.63,7.63-16.81,10.93-30.68,11.03c-15.38-0.11-27.02-5.05-34.58-14.66
            c-7.08-9-10.74-22.01-10.88-38.66c0.14-16.65,3.8-29.65,10.88-38.66c7.56-9.62,19.2-14.55,34.58-14.66
            c15.5,0.12,27.33,5.07,35.19,14.73c3.85,4.74,6.75,10.7,8.67,17.65l10.89-2.91c-2.32-8.55-5.97-15.92-10.94-22.03
            c-10.07-12.39-24.79-18.74-43.77-18.87h-0.08c-18.94,0.13-33.5,6.5-43.28,18.94c-8.7,11.07-13.19,26.46-13.35,45.76l0,0.05l0,0.05
            c0.15,19.3,4.64,34.7,13.35,45.76c9.78,12.43,24.34,18.81,43.28,18.94h0.08c16.83-0.12,28.7-4.52,38.48-14.29
            c12.79-12.78,12.4-28.79,8.19-38.63C189.23,114.41,183.46,108.68,175.58,104.9z M146.51,132.23c-7.04,0.4-14.36-2.76-14.72-9.53
            c-0.27-5.02,3.57-10.62,15.15-11.29c1.33-0.08,2.63-0.11,3.9-0.11c4.21,0,8.14,0.41,11.72,1.19
            C161.23,129.14,153.41,131.85,146.51,132.23z"
        />
      </g>
    </svg>
  );
};

export default ThreadsIcon;
